module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./ServiceStoreView.js"));
	}, "ServiceStoreView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ServiceStoreView!./src/pages/Shop/Member/Personal/ServiceCode/ServiceStore/ServiceStoreView.js
// module id = 1898
// module chunks = 367